import { render, staticRenderFns } from "./GSurveyAnswerAggregate.vue?vue&type=template&id=f4630f0a&v-if=selectedSurveyAnalysisChartType%20%3D%3D%3D%20chartTypeAnswerBarGraph&"
import script from "./GSurveyAnswerAggregate.vue?vue&type=script&lang=ts&"
export * from "./GSurveyAnswerAggregate.vue?vue&type=script&lang=ts&"
import style0 from "./GSurveyAnswerAggregate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports